export default "__VITE_ASSET__ChxGE94$__"